import { render, staticRenderFns } from "./boxtop.vue?vue&type=template&id=793c6b86&scoped=true&"
import script from "./boxtop.vue?vue&type=script&lang=js&"
export * from "./boxtop.vue?vue&type=script&lang=js&"
import style0 from "./boxtop.vue?vue&type=style&index=0&id=793c6b86&scoped=true&lang=scss&"
import style1 from "./boxtop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793c6b86",
  null
  
)

export default component.exports